<div class="h-52 md:h-72 container mx-auto w-full bg-cover bg-center flex flex-col justify-center items-center gap-2"
  style="background-image: url('../../../assets/images/leadership/leadership-banner.png'); ">
  <span class="font-medium text-white text-2xl md:text-3xl">Careers&#64;CarIQ</span>
  <span class="font-light text-white text-xl md:text-2xl px-5">Join Our Team</span>
</div>

<div class="flex flex-col items-center justify-center gap-5 mt-12">
  <span class="px-5 text-2xl md:text-3xl text-black font-light text-center w-full md:w-3/5">Diverse culture where
    curious minds collaborate </span>
</div>

<div class="w-full flex flex-col items-center justify-center gap-8 mt-10">

  <div class="flex items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div>
      <div class="flex flex-col items-start justify-start gap-4 mt-4">
        <h3 class="text-xl font-bold ">Lead/Senior Manager- Marketing & Communication</h3>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/experience.png" alt="" class="size-5">
          <p class="text-black text-sm">10+ years</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/job-location.png" alt="" class="size-5">
          <p class="text-black text-sm">Pune, Maharashtra</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/employment-type.png" alt="" class="size-5">
          <p class="text-black text-sm">Full Time</p>
        </div>
      </div>

    </div>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="text-sm">As the Senior Manager - Digital Marketing & Communication, you will be responsible for developing and executing comprehensive
      marketing strategies that combine product positioning with performance-driven campaigns. You will work closely
      with product, sales, and corporate marketing teams to craft compelling product narratives while optimizing digital
      marketing channels to maximize customer acquisition and engagement.</span>
  </div>
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Roles and Responsibilities</span>
    <ul class="list-disc list-inside text-lg">
      <span class="font-bold text-sm">Product Marketing:</span>

      <li class="mb-2 text-sm" *ngFor="let roles of roles1">
        {{roles}}
      </li>
    </ul>

    <ul class="list-disc list-inside text-lg">
      <span class="font-bold text-sm">Performance Marketing:</span>

      <li class="mb-2 text-sm" *ngFor="let roles of roles2">
        {{roles}}
      </li>
    </ul>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Required Skills & Qualifications :</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let skill of skills">
        {{skill}}
      </li>
    </ul>
  </div>

  <app-career-form-submission class="px-5 w-5/6 md:w-3/4" [jobDescription]="selectedJob"></app-career-form-submission>
</div>